import NumberIndicationAnalysisLayout from './NumberIndicationAnalysisLayout';
export default NumberIndicationAnalysisLayout;